import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ContactInformation.module.scss'
import { changeObjectPropertyAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const PhoneNumber = ({ t, validatePhoneNumber, phoneNumberError, phoneNumberValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const phoneNumber = useSelector((state) => state.app.contactInformation.phoneNumber)

  const handlePhoneNumber = (e) => {
    try {
      var x = e.currentTarget.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      let phoneNumberParsed = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
      dispatch(changeObjectPropertyAction('contactInformation', 'phoneNumber', phoneNumberParsed))
      validatePhoneNumber(phoneNumberParsed)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurPhoneNumber = (e) => {
    try {
      SetIsFocussed(false)
      var x = e.currentTarget.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      let phoneNumberParsed = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
      dispatch(changeObjectPropertyAction('contactInformation', 'phoneNumber', phoneNumberParsed))
      validatePhoneNumber(phoneNumberParsed)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <React.Fragment>
      <div className={[
        phoneNumberValid === true
          ? phoneNumberValid === ''
            ? ''
            : 'form-group has-success'
          : phoneNumberValid === false
            ? 'form-group has-error'
            : '',
        styles['fields_margin'],
      ].join(' ')}>
        <div className="ns-label-wrapper">
          <label className="ns-label" htmlFor="PhoneNumber">
            {t('contact_info.phone_number')}
          </label>
        </div>
        <div id="phone-number-hint" className="ns-hint">
          {t('contact_info.provide_a_phone_number')}
        </div>
        {(phoneNumberValid === true || phoneNumberValid === '') ? (
          null
        ) :
          (
            <span id="phone-number-error" className={isFocussed ? 'help-block-focused' : 'help-block'}>
              <i aria-label={t('shared.error')} className="fa fa-exclamation-circle error-indicator errorAlert" aria-hidden="true"></i>
              <span className="ns-visually-hidden">{t('shared.error')}</span> {t(phoneNumberError)}
            </span>
          )}
        <div style={{ display: "flex", overflow: "auto" }}>
          <input className={[
            'fw-20',
            (phoneNumberValid === true) ? 'ns-input--success' : '',
            (phoneNumberValid !== true && phoneNumberValid !== '') ? 'ns-input--error' : ''].join(' ')} id="PhoneNumber" name="PhoneNumber" type="text"
            aria-describedby="phone-number"
            style={{ flexGrow: 1, minWidth: "3em" }}
            onChange={handlePhoneNumber}
            onBlur={onBlurPhoneNumber}
            onFocus={() => SetIsFocussed(true)}
            value={phoneNumber}
            autoComplete="off"
            maxLength="12" />
          {(phoneNumberValid === true) && (
            <div style={{ display: "inline-flex", marginLeft: "1rem", alignItems: "center" }} ><i className="fa fa-check-circle fa-lg" aria-hidden="true"></i></div>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(PhoneNumber)